//https://www.sworkstudio.com/team

const dev = {
  API_ENDPOINT_URL: 'https://www.sworkstudio.com/team'
};

const prod = {
  API_ENDPOINT_URL: 'https://www.sworkstudio.com/team'
};

const test = {
  API_ENDPOINT_URL: 'https://www.sworkstudio.com/team'
};

//http://192.168.0.9:8000/api
const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
